// extracted by mini-css-extract-plugin
export default {"Right":"BuyForm_Right__YD7fL","Seller":"BuyForm_Seller__d+ECV","ListTime":"BuyForm_ListTime__EiG6M","Error":"BuyForm_Error__04jRH"};